export function isObject(v) {
  return typeof(v)==='object'&&v!==null
}
export function isEmptyObject(v) {
  return typeof(v)==='object'&&v!==null&&Object.keys(v).length<=0
}
export function isString(v) {
  return typeof(v)==='string'
}
export function isEmptyString(v) {
  return typeof(v)==='string'&&v.length<=0
}
export function isNonEmptyString(v) {
  return typeof(v)==='string'&&v.length>0
}
export function isNumber(v) {
  return typeof(v)==='number'
}
export function isZero(v) {
  return typeof(v)==='number'&&v===0
}
export function isPositiveNumber(v) {
  return typeof(v)==='number'&&v>0
}
export function isDate(v) {
  return v instanceof Date
}
export function isArray(v) {
  return Array.isArray(v)
}
export function isNonEmptyArray(v) {
  return Array.isArray(v)&&v.length>0
}



// WEBPACK FOOTER //
// ./src/util/TypeUtils.js